<div>
    <app-audi-text variant="order4" className="audi-type-normal" weight="bold" text="Customise Your New Plan">
    </app-audi-text><br /><br />
    <app-audi-text text="Please select Plan Type, Years and Distance:" variant="copy1">
    </app-audi-text>

    <br /><br />
    <div class="column__list">
        <div class="card__list">
            <app-audi-select inputId="customize-plan-type-select" label="Plan Type*" [options]="planTypeOptions" [(value)]="selectedPlanType"
                (valueChange)="onPlanTypeSelected($event)" isRequired="true">
            </app-audi-select>
        </div>
        <div class="card__list">
            <app-audi-select inputId="customize-plan-years-select" label="Years*" [options]="yearsOptions" [(value)]="selectedYears" (valueChange)="onYearsSelected()"
                isRequired="true">
            </app-audi-select>
        </div>
        <div class="card__list">
            <app-audi-select inputId="customize-plan-distance-select" label="Distance*" [options]="distanceOptions" [(value)]="selectedDistance"
                (valueChange)="onDistanceSelected()" isRequired="true">
            </app-audi-select>
        </div>
    </div>

    <app-audi-text text="* Indicates required fields" variant="copy2"></app-audi-text>

    <div *ngIf="customizedPlan">
        <br />
        <div class="column__list">
            <div class="card__list">
                <app-new-plan-option [data]="customizedPlan"></app-new-plan-option>
            </div>
            <div class="card__list">
            </div>
            <div class="card__list">
            </div>
        </div>
    </div>

    <div [hidden]="customizedPlan">
        <br />
    </div>
</div>